<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <h1>Detalle de {{ beneficio.tipo }}</h1>
      </v-col>
      <v-col cols="12" md="6" style="text-align: end;">
        <v-btn
          class="common-botton mr-3"
          dark
          @click="editarBeneficio"
          v-if="canEdit"
        >
          <v-icon class="mr-2">mdi-pencil</v-icon>
          <span>Editar</span>
        </v-btn>
        <v-btn
          class="common-botton"
          dark
          @click="$router.push('/administracion/asistencias-beneficios')"
        >
          <v-icon class="mr-2">mdi-arrow-left</v-icon>
          <span>Volver</span>
        </v-btn>
      </v-col>
    </v-row>
    
    <v-card class="mt-5" elevation="3">
      <v-card-text>
        <div v-if="!loading">
          <v-row>
            <v-col cols="12">
              <h2 class="text-h4 mb-2 primary--text">
                {{ beneficio.nombre }}
                <v-chip
                  class="ml-3"
                  :color="getStatusColor(beneficio.status)"
                  text-color="white"
                  small
                >
                  {{ beneficio.status }}
                </v-chip>
              </h2>
              <p class="subtitle-1 mb-4">{{ beneficio.nombreCorto }}</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Tipo</span>
              <br />
              <span>{{ beneficio.tipo }}</span>
            </v-col>
            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Categoria</span>
              <br />
              <span>{{ beneficio.categoria }}</span>
            </v-col>
            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Descripción</span>
              <br />
              <span>{{ beneficio.descripcion }}</span>
            </v-col>
          </v-row>
          <v-row>

            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Alianza Inter.mx</span>
              <br />
              <span>{{ alianzaNombre }}</span>
            </v-col>

            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Nombre corto para SMS</span>
              <br />
              <span>{{ beneficio.nombreCorto }}</span>
            </v-col>

            <v-col cols="4">
              <span class="text-header-data font-weight-bold">SLA</span>
              <br />
              <span>{{ beneficio.sla }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <span class="text-header-data font-weight-bold">Especial</span>
              <br />
              <span>{{ beneficio.especial == 0 ? "No" : "Si"}}</span>
            </v-col>
            <v-col cols="12" md="4">
              <span class="text-header-data font-weight-bold">Telefonía</span>
              <br />
              <span>{{ formatBoolean(beneficio.telefonia) }}</span>
            </v-col>
            <v-col cols="12" md="4">
              <span class="text-header-data font-weight-bold">Periodicidad</span>
              <br />
              <span>{{ beneficio.periodicidad || "No especificado" }}</span>
            </v-col>
            <v-col cols="12" md="4" v-if="beneficio.mesDisponibilidad">
              <span class="text-header-data font-weight-bold">Mes de Disponibilidad</span>
              <br />
              <span>{{ beneficio.mesDisponibilidad }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <span class="text-header-data font-weight-bold">Monto</span>
              <br />
              <span>${{ formatMonto(beneficio.monto) }}</span>
            </v-col>
            <v-col cols="12" md="4">
              <span class="text-header-data font-weight-bold">Eventos por Periodo</span>
              <br />
              <span>{{ beneficio.eventosPeriodo }}</span>
            </v-col>


            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold" >Proveedor</span>
              <br />
              <span>{{ proveedorData.nombre  }}</span>
            </v-col>
            <v-col cols="12" md="4" v-if="beneficio.codigoProveedorId">
              <span class="text-header-data font-weight-bold">Código Proveedor</span>
              <br />
              <span>{{ beneficio.codigoProveedorId }}</span>
            </v-col>
            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold">IVR Atención a Clientes del Proveedor</span>
              <br />
              <span>{{ proveedorData.ivr }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold">Nombre Responsable Proveedor</span>
              <br />
              <span>{{ proveedorData.responsable_cuenta }}</span>
            </v-col>
            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold">Telefono Responsable Proveedor</span>
              <br />
              <span>{{ proveedorData.telefono_responsable }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold">Nombre Responsable TI</span>
              <br />
              <span>{{ proveedorData.responsable_tecnologia }}</span>
            </v-col>
            <v-col cols="12" md="4" v-if="proveedorData">
              <span class="text-header-data font-weight-bold">Telefono Responsable TI</span>
              <br />
              <span>{{ proveedorData.telefono_ti }}</span>
            </v-col>
          </v-row>
        </div>

        <v-container v-else>
          <v-row justify="center" class="pa-5">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
            ></v-progress-circular>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mainAxios } from "../../../../mainAxios";
import { getProveedor } from "../../../../services/clubBeneficios/clubBeneficios";

export default {
  name: "DetalleBeneficio",
  components: {
  },
  data() {
    return {
      loading: true,
      beneficio: {},
      alianzaNombre: "",
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: JSON.parse(localStorage.getItem("roles")),
      proveedorData: null,
      meses: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ]
    };
  },
  computed: {
    canEdit() {
      let canEdit = false;
      let roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });
      const rolesConPermiso = ["ADMIN", "MANAGERCC", "OPERADOR"];
      roles.forEach((element) => {
        if (rolesConPermiso.includes(element)) {
          canEdit = true;
        }
      });
      return canEdit;
    }
  },
  mounted() {
    this.getBeneficio();
  },
  methods: {
    getBeneficio() {
      this.loading = true;
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      
      mainAxios
        .get(`/v1/club-beneficios/${this.$route.params.id}`, config)
        .then((response) => {
          this.beneficio = response.data.data;
          
          if (this.beneficio.alianzaIntermxId) {
            this.getDetalleAlianza(this.beneficio.alianzaIntermxId);
          }
          if (this.beneficio.asistenciadoraId) {
            this.getDetalleProveedor(this.beneficio.asistenciadoraId);
          }
        })
        .catch((error) => {
          console.error("Error al obtener beneficio:", error);
          this.$toast.error("Error al cargar el beneficio", {
            position: "top-right",
            timeout: 3000
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    getDetalleAlianza(alianzaId) {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      
      mainAxios
        .get("/v1/club-beneficios/alianzas", config)
        .then((response) => {
          const alianzas = response.data.data;
          const alianza = alianzas.find(a => a.id == alianzaId);
          if (alianza) {
            this.alianzaNombre = alianza.nombre;
          }
        })
        .catch((error) => {
          console.error("Error al obtener alianza:", error);
        });
    },

    async getDetalleProveedor(proveedorId) {
      const proveedores = await getProveedor();
      console.log("proveedores", proveedores)
      const proveedor = proveedores.find(a => a.id == proveedorId);
      if (proveedor) {
        this.proveedorData = proveedor;
      }
    },
    
    getStatusColor(status) {
      const statusColors = {
        "Activo": "green",
        "Inactivo": "amber darken-2",
        "Baja": "red"
      };
      
      return statusColors[status] || "grey";
    },
    
    formatMonto(monto) {
      return monto.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatBoolean(value) {
      return value ? "Si" : "No";
    },
    
    getMesNombre(mesNumero) {
      return this.meses[mesNumero - 1] || "";
    },
    
    editarBeneficio() {
      this.$router.push(`/administracion/asistencias-beneficios/editar/${this.$route.params.id}`);
    }
  }
};
</script>

<style scoped>
.text-header-data {
  color: #00a7e4;
  font-size: 14px;
}

h3 {
  color: #00a7e4;
  font-size: 18px;
}

.v-card {
  border-radius: 8px;
}
</style> 
